
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LanguageContainer, LanguageItem } from './style';
import { languagesAllowed } from '../../components/i18n';

const LanguageSelector = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { language } = useParams();
    const { i18n, t } = useTranslation();

    const changeLocale = (language) => {
        const pathArray = location.pathname.split('/');
        pathArray[1] = language;
        i18n.changeLanguage(language);
        navigate(pathArray.join('/'));
    }

    if (languagesAllowed.length <= 1) {
        return null;
    }

    return <LanguageContainer>
        {languagesAllowed.map((languageAllowed, idx) => {
            return (
                <LanguageItem 
                    onClick={() => changeLocale(languageAllowed)}
                    bold={language === languageAllowed ? 'bold' : 'normal'}
                    key={idx}
                >
                    {t(`utils.languages.${languageAllowed.replace('-', '_')}`)}        
                </LanguageItem>
            )
        })}
    </LanguageContainer>
}

export default LanguageSelector